import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	AllBanksListState,
	BankEssential,
	BankState,
	getUserAllBanks,
} from "../actions/bank"

const initialState: AllBanksListState = {
	loading: false,
	error: undefined,
	list: [],
	selected: undefined,
}

const bankAllSlice = createSlice({
	name: "banksUser",
	initialState: initialState,
	reducers: {
		clearError: (state: AllBanksListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: AllBanksListState) => {
			state.loading = false
			state.error = undefined
			state.list = []
			state.selected = undefined
		},
		selectBank: (
			state: AllBanksListState,
			action: PayloadAction<BankEssential>
		) => {
			state.selected = action?.payload
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(getUserAllBanks.pending, (state: AllBanksListState) => {
				state.loading = true
				state.error = undefined
			})
			.addCase(
				getUserAllBanks.fulfilled,
				(state: AllBanksListState, action: PayloadAction<BankState[]>) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload || undefined
				}
			)
			.addCase(getUserAllBanks.rejected, (state: AllBanksListState, action) => {
				state.loading = false
				state.error = action?.payload.message
			})
	},
})

export const { clearError, resetDefault, selectBank } = bankAllSlice.actions

export default bankAllSlice.reducer
